export const DEFAULT_DURATION = 4_000;
